"use client";
import InputField from "../../../components/common/InputField"; 

const RequestSendModal = () => {
  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <InputField label="Origin Hub" placeholder="Riyadh" />
        <InputField label="Destination Hub" placeholder="Dammam" />
        <InputField
          label="Required Weight Capacity (kg)"
          className=""
          placeholder="100"
        />
        <InputField
          className=""
          label="Required Volume Capacity (m³)"
          placeholder="10"
        />
      </div>
    </div>
  );
};

export default RequestSendModal;
